export default {
  retailerId: true,
  shippingLocationId: true,
  purchaseOrder: false,
  status: true,
  email: false,
  type: false,
  sourceId: false,
  paymentTermsId: true,
  vendorId: true,
  buyer: false,
  shippingMethodId: false,
  shipOn: false,
  cancelOn: false,
  note: false,
  cartName: false,
  vendorNote: false,
  deliveryNote: false,
  shippingNote: false,
  tagFor: false,
  discount: false,
  warehouseId: false,
	containerId: false,
  orderActivity: false
};
